import UCPPage from "./UCPPage";
import { UCPContextProviders } from "./context";

const UCPPageV2 = () => {
  return (
    <UCPContextProviders>
      <UCPPage />
    </UCPContextProviders>
  );
};

export default UCPPageV2; 